import { createFileRoute, redirect } from '@tanstack/react-router'

import { isAdmin } from '@/hooks/use-is-admin'

export const Route = createFileRoute('/_private/')({
  beforeLoad: () => {
    throw redirect({
      to: isAdmin() ? '/admin/partners' : '/dashboard',
      replace: true,
    })
  },
})
